import { defineStore } from 'pinia';
import { nft_abi, market_abi } from '@/utils/ABI.js';
// import WalletConnect from '@walletconnect/client';
// import SignClient from '@walletconnect/sign-client';
// import EthereumProvider from '@walletconnect/ethereum-provider';
// import { PairingTypes, SessionTypes } from '@walletconnect/types';
// import QRCodeModal from '@walletconnect/qrcode-modal';
import WalletConnectProvider from '@walletconnect/web3-provider';
import Web3 from 'web3';
import { Toast } from 'vant';
import router from '@/router';
import { Notify } from 'vant';
const nft_address = '0x80B03Efc7f874717FEEfA849115f1CFe6d1C12bb';
const market_address = '0x35cb37474c3924Bb5458136949c64F46fAc2E074';
const hashType = [
  'HashType.one',
  'HashType.two',
  'HashType.three',
  'HashType.four',
  'HashType.five',
];
// const isNetwork = 97;
const isNetwork = 56;
const isBscNet = 'bsc-testnet';
// const isBscNet = 'bsc-mainnet';
export const commonStore = defineStore('common', {
  state: () => {
    return {
      allMethods: {},
      // mangerAddr: '0x5F3A3DFB14c459EFF4867aC26Cc6E55cf398C52E', //管理员地址
      mangerAddr: '0xbae554A049B8Aeb725e193b1dfa25654962f57C8', //管理员地址
      count: 0,
      address: sessionStorage.getItem('address') || false,
      loadingShow: false,
      marketMethods: {},
      marketEmpower: false,
      userInfo: {
        userinfo_: {
          nftprofit: '',
          extprofit: '',
        },
        sons_: [],
      },
      linkShow: false,
      market_address: '0x35cb37474c3924Bb5458136949c64F46fAc2E074',
      priceArr: [
        100, 130, 169, 219.7, 285.61, 371.29, 482.68, 627.48, 815.73, 1060.45,
      ],
      empowerShow: false,
      empowerType: 1,
      tokenId: 0,
      hashArr: JSON.parse(localStorage.getItem('hashArr')) || [],
      accountShow: false,
      network: null,
      walletType: localStorage.getItem('walletType') || null,
    };
  },
  actions: {
    setWalletType(str) {
      this.walletType = str;
      localStorage.setItem('walletType', str);
    },
    clearHash() {
      this.hashArr = [];
      localStorage.removeItem('hashArr');
    },
    setAccountShow(bool) {
      this.accountShow = bool;
    },
    addHash(hash, type) {
      const params = {
        hash,
        text: hashType[type],
      };
      this.hashArr.push(params);
      localStorage.setItem('hashArr', JSON.stringify(this.hashArr));
    },
    setEmpowerType(num, token) {
      this.empowerType = num;
      if (token) {
        this.tokenId = token;
      }
    },
    showEmpower(bool) {
      this.empowerShow = bool;
    },
    setLinkShow(bool) {
      this.linkShow = bool;
    },
    setLoading(bool) {
      this.loadingShow = bool;
    },
    async getAddress(web3) {
      const account = await web3.eth.getCoinbase();
      if (account) {
        return account;
      }
      return false;
    },
    async getBscAddress(web3) {
      const account = await web3.eth.getAccounts();
      if (account) {
        return account[0];
      }
      return false;
    },
    async getUserInfo() {
      try {
        this.userInfo = await this.marketMethods
          .getUserInfo(this.address)
          .call();
      } catch (error) {
        console.log(error);
        Toast(error);
      }
    },
    accountsChanged(account) {
      if (account.length > 0) {
        sessionStorage.clear();
        this.address = account[0];
        sessionStorage.setItem('address', this.address);
      } else {
        sessionStorage.clear();
        this.address = '';
        router.replace('/');
      }
    },
    switchNetwork() {
      try {
        window.ethereum.request({
          method: 'wallet_switchEthereumChain',
          params: [{ chainId: Web3.utils.toHex(isNetwork) }],
        });
      } catch (switchError) {
        // This error code indicates that the chain has not been added to MetaMask.
        if (switchError.code === 4902) {
          alert('add this chain id');
        }
      }
    },
    async switchBSCNet() {
      try {
        await window.BinanceChain.switchNetwork(isBscNet);
      } catch (switchError) {
        // This error code indicates that the chain has not been added to MetaMask.
        if (switchError.code === 4902) {
          alert('add this chain id');
        }
      }
    },
    networkChanged(network) {
      console.log(network);
      if (network != isNetwork) {
        this.switchNetwork();
        return;
      }
      this.initWeb3();
    },
    BSCNetChanged(network) {
      console.log(network);
      if (network != isBscNet && network != '0x38') {
        this.switchBSCNet();
        return;
      }
      this.initBSCWeb3();
    },
    disconnect() {
      sessionStorage.clear();
      localStorage.removeItem('walletconnect');
      this.address = '';
      router.replace('/');
    },
    async initWeb3() {
      const web3 = new Web3(window.ethereum);
      if (window.ethereum) {
        window.ethereum.enable();
        ethereum.on('accountsChanged', this.accountsChanged);
        ethereum.on('networkChanged', this.networkChanged);
        ethereum.on('close', this.disconnect);
      } else {
        alert('no wallet');
        return;
      }
      const rpoContract = new web3.eth.Contract(nft_abi, nft_address);
      this.allMethods = rpoContract.methods;
      const timer = setInterval(async () => {
        const address = await this.getAddress(web3);
        if (address) {
          this.address = address;
          this.network = ethereum.networkVersion;
          sessionStorage.setItem('address', this.address);

          if (this.network != isNetwork) {
            this.switchNetwork();
            this.address = '';
          }
          clearInterval(timer);
        }
      }, 1000);
    },
    async initBSCWeb3() {
      const web3 = new Web3(window.BinanceChain);
      if (window.BinanceChain) {
        window.BinanceChain.enable();
        BinanceChain.on('accountsChanged', this.accountsChanged);
        BinanceChain.on('chainChanged', this.BSCNetChanged);
        BinanceChain.on('disconnect', this.disconnect);
        // BinanceChain.on('close', this.disconnect);
      } else {
        alert('no wallet');
        return;
      }

      const rpoContract = new web3.eth.Contract(nft_abi, nft_address);
      this.allMethods = rpoContract.methods;
      this.network = window.BinanceChain.chainId;
      console.log(window.BinanceChain.chainId);
      if (this.network != isBscNet && this.network !== '0x38') {
        this.switchBSCNet();
        this.address = '';
      }
      const account = await web3.eth.getAccounts();
      if (account) {
        this.address = account[0];
        sessionStorage.setItem('address', this.address);
      }
    },
    initMarketWeb3() {
      const walletObj =
        this.walletType == 'BinanceChain'
          ? window.BinanceChain
          : window.ethereum;
      const web3 = new Web3(walletObj);
      const rpoContract = new web3.eth.Contract(market_abi, market_address);
      this.marketMethods = rpoContract.methods;
      this.marketEmpower = true;
      this.getUserInfo();
    },
    async walletConnect() {
      // const provider = await WalletConnectProvider.init({
      //   projectId: '774b1e4252de48c3997d66ac5f5078d8',
      // });

      const provider = new WalletConnectProvider({
        infuraId: '774b1e4252de48c3997d66ac5f5078d8',
        qrcode: true,
      });

      if (!provider.on) {
        return;
      }
      // Subscribe to accounts change
      provider.on('accountsChanged', this.accountsChanged);
      provider.on('disconnect', (code, reason) => {
        this.disconnect();
      });
      provider.on('close', () => {
        localStorage.removeItem('walletconnect');
      });
      await provider.enable();
      const web3 = new Web3(provider);
      const accounts = await web3.eth.getAccounts();
      this.address = accounts[0];
      const rpoContract = new web3.eth.Contract(nft_abi, nft_address);
      this.allMethods = rpoContract.methods;
      this.network = await web3.eth.net.getId();

      // if (this.network != isNetwork) {
      //   try {
      //     window.ethereum.request({
      //       method: 'wallet_switchEthereumChain',
      //       params: [{ chainId: Web3.utils.toHex(isNetwork) }],
      //     });
      //   } catch (switchError) {
      //     Notify({
      //       type: 'warning',
      //       message: switchError.message,
      //       background: '#3761ea',
      //       color: '#fff',
      //     });
      //   }
      // }
      // this.network = await web3.eth.net.getId();
      this.linkShow = false;
    },
    closeApp() {
      newWeb3.currentProvider.close();
    },
  },
});
